import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {useFormik} from 'formik'
import '../../../../_metronic/assets/sass/components/forgotPassword.scss'
import CommonLogin from '../../../../_metronic/helpers/components/login-components/CommonLogin'
import {Auth} from 'aws-amplify'
import {useLazyQuery, useMutation} from '@apollo/client'
import {GETUSERPROFILE, UPDATE_USER_SIGNIN_SIGNOUT_TIME} from '../../../../utils/GraphQLAPI'
import {adminRoles} from '../../../../utils/helper'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import * as authHelper from '../core/AuthHelpers'
import ContactTPVAdmin from './ContactTPVAdmin'
const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

const MySwal = withReactContent(Swal)

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email address is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
}

export const Login = () => {
  const [passwordType, setPasswordType] = useState<any>('password')
  const [userRole, setUserRole] = useState<string>()
  const [header, setHeader] = useState<string>()
  const [subheader, setSubHeader] = useState<string>()
  const loggedIn = sessionStorage.getItem('loggedIn')
  const accessToken = localStorage.getItem('_accesstoken')
  const [paramName, setParamName] = useState('')
  useEffect(() => {
    loggedIn && accessToken && getUserData()
  }, [])
  const navigate = useNavigate()

  // getting the params from url
  const getUserParams = useParams()

  useEffect(() => {
    const role: any = getUserParams.adminUser
    navigateUser(role)
    if (getUserParams.adminUser === 'tpvadmin') {
      setParamName('TPV Admin')
    } else if (getUserParams.adminUser === 'systemadmin') {
      setParamName('System Admin')
    } else if (getUserParams.adminUser === 'agent') {
      setParamName('Agent Admin')
    } else if (getUserParams.adminUser === 'salesadmin') {
      setParamName('Sales Admin')
    } else if (getUserParams.adminUser === 'qcuser') {
      setParamName('QC User')
    } else if (getUserParams.adminUser === 'liveagent') {
      setParamName('Live Agent')
    }
  }, [getUserParams])

  // Capture Signin and Signout Time
  const [updateUserSigninSignoutTime] = useMutation(UPDATE_USER_SIGNIN_SIGNOUT_TIME, {
    variables: {
      signIn: true,
    },
  })

  const [getUserData] = useLazyQuery(GETUSERPROFILE, {
    fetchPolicy: 'network-only',
    onCompleted: async (data) => {
      data.getUserProfile.isActive ? checkUserRole(data) : navigate(`/${userRole}/authentication`)
    },
    onError: (e) => {
      console.warn(e)
      MySwal.fire({
        icon: 'error',
        title: 'Error',
        text: e.message,
      })
    },
  })

  const checkUserRole = (data: any) => {
    if (data.getUserProfile.userRole === 'TPV_ADMIN') {
      sweetAlert(data, adminRoles.TPV_ADMIN, 'TPV_ADMIN', 'tpv-dashboard')
    }
    if (data.getUserProfile.userRole === 'LIVE_AGENT') {
      sweetAlert(data, adminRoles.LIVE_AGENT, 'LIVE_AGENT', 'liveagent-call')
    }
    data.getUserProfile.userRole === 'USER' &&
      data.getUserProfile.members?.map((user: any) => {
        switch (user.role) {
          case 'AGENT':
            sweetAlert(data, adminRoles.AGENT_ADMIN, 'AGENT_ADMIN', 'agent-dashboard')
            break
          case 'SYSTEM_ADMIN':
            if (data?.getUserProfile?.client?.clientBusinessType === 'Lead Gen')
              sweetAlert(data, adminRoles.SYSTEM_ADMIN, 'SYSTEM_ADMIN', 'customer-list')
            else sweetAlert(data, adminRoles.SYSTEM_ADMIN, 'SYSTEM_ADMIN', 'dashboard')
            break
          case 'SALES_ADMIN':
            sweetAlert(data, adminRoles.SALES_ADMIN, 'SALES_ADMIN', 'sales-dashboard')
            break
          case 'QC_USER':
            sweetAlert(data, adminRoles.QC_USER, 'QC_USER', 'qc-dashboard')
            break
          default:
            break
        }
      })
  }

  const sweetAlert = (data: any, adminRole: any, roleName: any, redirectDashboardURL: any) => {
    console.log('redirectDashboardURL', redirectDashboardURL)
    const URlDetail = getUrlRedirect(data)
    if (
      getUserParams.adminUser === adminRole &&
      (data.getUserProfile.userRole === 'TPV_ADMIN' ||
        data.getUserProfile.userRole === 'LIVE_AGENT' ||
        data.getUserProfile.userRole === 'USER')
    ) {
      const options: any = {
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        title: data.getUserProfile.signOutAt ? 'Welcome Back!' : 'Welcome To TPV!',
        text: `You have successfully logged in as a ${URlDetail?.name}!`,
        icon: 'success',
        buttonsStyling: false,
      }
      !loggedIn && MySwal.fire(options)
      navigate(`/${userRole}/${redirectDashboardURL}`)
      sessionStorage.setItem('loggedIn', 'true')
      localStorage.setItem('adminDashboardUrl', `/${userRole}/${redirectDashboardURL}`)
      updateUserSigninSignoutTime()
    } else {
      sessionStorage.removeItem('loggedIn')
      MySwal.fire({
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        icon: 'error',
        title: `You are not valid ${paramName} user for this URL`,
        text: 'Kindly click to navigate to the corresponding url',
        confirmButtonText: 'Click Here',
      }).then(() => {
        navigate(`/${URlDetail?.url}/login`)
        authHelper.removeAuth()
        localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
        window.localStorage.clear()
      })
    }
  }

  const getUrlRedirect = (data: any) => {
    if (data.getUserProfile.userRole === 'TPV_ADMIN') {
      return {url: 'tpvadmin', name: 'TPV Admin'}
    } else if (data.getUserProfile.userRole === 'LIVE_AGENT') {
      return {url: 'liveagent', name: 'Live Agent'}
    } else if (data.getUserProfile.members[0].role === 'AGENT') {
      return {url: 'agent', name: 'Agent Admin'}
    } else if (data.getUserProfile.members[0].role === 'SALES_ADMIN') {
      return {url: 'salesadmin', name: 'Sales Admin'}
    } else if (data.getUserProfile.members[0].role === 'SYSTEM_ADMIN') {
      return {url: 'systemadmin', name: 'System Admin'}
    } else if (data.getUserProfile.members[0].role === 'QC_USER') {
      return {url: 'qcuser', name: 'QC User'}
    } else if (data.getUserProfile.members[0].role === 'LIVE_AGENT') {
      return {url: 'liveagent', name: 'Live Agent'}
    } else {
      return {url: '', name: ''}
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values) => {
      try {
        // calling auth function from aws amplify api
        await Auth.signIn({
          username: values.email.toLowerCase(),
          password: values.password,
        })
        await getUserData()
      } catch (e: any) {
        MySwal.fire({
          icon: 'error',
          title: 'Error',
          text: e.message,
        })
      }
    },
  })

  // Params based Redirect
  const navigateUser = (role: any) => {
    switch (role) {
      case adminRoles.TPV_ADMIN: {
        setHeader('T P V')
        setSubHeader('TPV Admin Login')
        setUserRole('tpvadmin')
        break
      }
      case adminRoles.AGENT_ADMIN: {
        setHeader('A G E N T')
        setSubHeader('Agent Login')
        setUserRole('agent')
        break
      }
      case adminRoles.SYSTEM_ADMIN: {
        setHeader('S Y S T E M')
        setSubHeader('System Admin Login')
        setUserRole('systemadmin')
        break
      }
      case adminRoles.SALES_ADMIN: {
        setHeader('S A L E S')
        setSubHeader('Sales Admin Login')
        setUserRole('salesadmin')
        break
      }
      case adminRoles.QC_USER: {
        setHeader('Q C')
        setSubHeader('QC User Login')
        setUserRole('qcuser')
        break
      }
      case adminRoles.LIVE_AGENT: {
        setHeader('L I V E  A G E N T')
        setSubHeader('Live Agent Login')
        setUserRole('liveagent')
        break
      }
      default: {
        navigate('/pageNotFound')
      }
    }
  }

  const showPassword = () => {
    passwordType === 'password' ? setPasswordType('text') : setPasswordType('password')
  }
  return (
    <>
      {!(loggedIn && accessToken) && (
        <div
          className='d-flex flex-column flex-lg-row h-100 flex-column-fluid bgi-size-cover'
          style={{
            backgroundImage: 'linear-gradient(rgb(35, 56, 119), rgb(12, 20, 43))',
          }}
        >
          <CommonLogin role={header} />
          {/* </div> */}
          {/* <div className='col align-self-center'> */}
          <div className='d-flex align-items-center justify-content-center flex-lg-row-fluid mt-5 order-1 order-lg-2'>
            <div className='card card-custom px-8 py-9 ml-5 bg-white h-70 w-500px'>
              <form
                className='form'
                onSubmit={formik.handleSubmit}
                noValidate
                id='kt_login_signin_form'
              >
                <div className='mt-5'>
                  {/* <div className='text-center'>
                    <h1 className='text-black fw-bolde'>Sign In</h1>
                  </div>   */}
                  <h1 className='text-black fw-bolde text-center'>{subheader}</h1>
                </div>

                <div className='p-5'>
                  {/* begin::Form group */}
                  <div className='fv-row mb-8'>
                    <input
                      placeholder='Email'
                      {...formik.getFieldProps('email')}
                      className={clsx(
                        'form-control bg-transparent',
                        {'is-invalid': formik.touched.email && formik.errors.email},
                        {
                          'is-valid': formik.touched.email && !formik.errors.email,
                        }
                      )}
                      type='email'
                      name='email'
                      autoComplete='off'
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <div role='alert'>{formik.errors.email}</div>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* end::Form group */}

                  {/* begin::Form group */}
                  <div className='fv-row mb-4'>
                    <div className='position-relative'>
                      <input
                        type={passwordType}
                        placeholder='Password'
                        autoComplete='off'
                        {...formik.getFieldProps('password')}
                        className={clsx(
                          'form-control bg-transparent',
                          {'is-invalid': formik.touched.password && formik.errors.password},
                          {'is-valid': formik.touched.password && !formik.errors.password}
                        )}
                      />
                      <div
                        style={{
                          position: 'absolute',
                          right: '50px',
                          top: '50%',
                          transform: 'translate(50%, -45%)',
                        }}
                      >
                        {passwordType === 'password' ? (
                          <i
                            className='bi bi-eye-slash'
                            style={{fontSize: '23px'}}
                            onClick={showPassword}
                          ></i>
                        ) : (
                          <i
                            className='bi bi-eye'
                            style={{fontSize: '23px'}}
                            onClick={showPassword}
                          ></i>
                        )}
                      </div>
                    </div>
                    {formik.touched.password && formik.errors.password && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <div role='alert'>{formik.errors.password}</div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-6'>
                    <div />

                    {/* begin::Link */}
                    <Link to={`/${userRole}/forgot-password`} className='link-primary'>
                      Forgot Password ?
                    </Link>
                    {/* end::Link */}
                  </div>

                  {/* begin::Action */}
                  <div className='d-flex mb-5 align-items-center justify-content-center'>
                    <button
                      type='submit'
                      id='kt_sign_in_submit'
                      className='btn btn-primary btn-lg w-100'
                      disabled={formik.isSubmitting || !formik.isValid}
                    >
                      <span className='indicator-label'>
                        Sign In{' '}
                        {formik.isSubmitting ? (
                          <div className='spinner-border text-light spinner-border-sm'></div>
                        ) : null}{' '}
                      </span>
                    </button>
                  </div>
                  {/* end::Action */}

                  <ContactTPVAdmin />
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  )
}